import React, {
  ComponentType,
  forwardRef,
  HTMLAttributes,
  memo,
  RefAttributes,
} from "react";
import classNames from "classnames";

import { ODSColumnProps } from "./ODSColumn.types";

const ODSColumn = forwardRef<HTMLElement, ODSColumnProps>(
  (
    {
      as: HtmlTag = "div",
      children,
      className,
      visibility = true,
      ...rest
    }: ODSColumnProps,
    ref
  ) => {
    const Component = HtmlTag as unknown as ComponentType<
      HTMLAttributes<HTMLElement> & RefAttributes<HTMLElement>
    >;

    return visibility ? (
      <Component
        className={classNames("ODSContainer-basic--vertical", className)}
        ref={ref}
        {...rest}
      >
        {children}
      </Component>
    ) : null;
  }
);

ODSColumn.displayName = "ODSColumn";

export default memo(ODSColumn);
